// Single source of truth for copy.

export const translations = {
  en: {
    meta: {
      authorName: 'Alexandros Papadakis',
      seriesName: 'The Wrath of a Requiem',
      bookOne: 'The Dance of the Vespershade',
      genre: 'A dark fantasy series',
    },
    nav: {
      home: 'Home',
      book: 'The Book',
      author: 'The Author',
      newsletter: 'Letters',
      buy: 'Read',
    },
    hero: {
      eyebrow: 'A dark fantasy series',
      tagline:
        'A mythic world ruled by unseen powers. A dance of demons, mortals, and the long fall of empires.',
      bookOneLabel: 'Book One',
      sample: 'Free sample',
      buyNow: 'Buy it now',
    },
    book: {
      heading: 'The Dance of the Vespershade',
      blurb:
        '“The glow reveals the image, not the truth. Tomorrow the sun will reign again; no rain will soak these lands further — not for now, not with water.”',
      blurbBody:
        'In a mythic world governed by unseen powers, fate binds demons, mortals, elves and the Rethien in an endless dance of conflict. Through wondrous landscapes and otherworldly realms, intrigue and reversal trace a story of suffering and of fierce, heroic survival.\n\nLusiana faces deadly peril as a long-buried truth turns the balances. Abaste and the Wolves spill outward, scattering death and terror. Elvenya walks between life and death, where a single misstep means her family’s ruin.\n\nWho will hear the song of a ruinous love, when its consequences have plunged the world into endless war?',
      blurbCoda: 'This journey no longer belongs to the author, but to the story itself. Will you dare to follow it?',
      coverCaption: 'Greek edition · Εκδόσεις Πηγή',
    },
    author: {
      heading: 'The Author',
      bio:
        'Alexandros Papadakis writes from the long shadow cast by myth. His work braids political tragedy with the inward life of those who outlive their own legends. He lives in Greece, between the page and the sea.',
      facts: {
        born: 'Crete',
        lives: 'Greece',
        subject: 'Political tragedy in dark fantasy',
      },
    },
    newsletter: {
      heading: 'Be the first to know',
      body:
        'Updates on the book, the series, and what comes next.',
      placeholder: 'Your email address',
      submit: 'Join the list',
      submitting: 'Sending…',
      success:
        'Thank you. The next word from the requiem will reach you here.',
      error: 'Something went wrong. Try again in a moment.',
      privacy: 'Unsubscribe anytime.',
    },
    buy: {
      heading: 'Where to read',
      body:
        'The Greek edition is available now from Εκδόσεις Πηγή. English translation arrives at launch — leave your email above and we will write the moment it lands.',
      comingSoon: 'Coming soon',
      open: 'Open',
    },
    footer: {
      tagline: 'A dark fantasy series by Alexandros Papadakis',
      copyright: '© {{year}} Alexandros Papadakis. All rights reserved.',
      contact: 'Contact',
      follow: 'Follow',
    },
    cookies: {
      title: 'A note on cookies',
      body:
        'We use cookies to understand how readers find this site and to improve your experience. You can decline without affecting any functionality.',
      accept: 'Accept',
      decline: 'Decline',
    },
  },

  gr: {
    meta: {
      authorName: 'Αλέξανδρος Παπαδάκης',
      seriesName: 'Η Οργή ενός Ρέκβιεμ',
      bookOne: 'Ο Χορός των Βέσπερσεϊντ',
      genre: 'ΣΚΟΤΕΙΝΗ ΕΠΙΚΗ ΦΑΝΤΑΣΙΑ',
    },
    nav: {
      home: 'Αρχικη',
      book: 'Το Βιβλιο',
      author: 'Ο Συγγραφεας',
      newsletter: 'Newsletter',
      buy: 'Αναγνωση',
    },
    hero: {
      eyebrow: '',
      tagline:
        'Όταν μια δολοφονία συντρίβει την ειρήνη του Γκράντενλιφ, κάτι ξυπνά στο αίμα της Λουσιάνας – κάτι που μπορεί να κρατήσει ζωντανό έναν καταδικασμένο στρατιώτη… με τρομερό τίμημα.',
      bookOneLabel: 'Βιβλιο Πρωτο',
      sample: 'Διαβασε δωρεαν αποσπασμα',
      buyNow: 'Αγορασε το τωρα',
    },
    book: {
      heading: 'Ο Χορός των Βέσπερσεϊντ',
      blurb:
        '«Η λάμψη φανερώνει την εικόνα, όχι την αλήθεια. Αύριο και πάλι ο ήλιος θα βασιλεύει, καμιά βροχή δεν θα μουσκέψει άλλο αυτά τα χώματα∙ όχι προς το παρόν, όχι με νερό».',
      blurbBody:
        'Το όραμα των Βέιλαρ: Λευκές φωτιές, η μία ντυμένη στα κόκκινα να οδηγεί τις υπόλοιπες, που φούντωναν και έσβηναν, μέχρι που η κόκκινη έγινε και εκείνη λευκή.\n\nΣε έναν μυθικό κόσμο που εξουσιάζεται από αφανείς οντότητες, η μοίρα δένει δαίμονες, ανθρώπους, ξωτικά και Ρέθιεν σε έναν αέναο χορό συγκρούσεων. Μέσα σε μαγευτικά τοπία και εξωπραγματικά βασίλεια, ίντριγκες και ανατροπές σκιαγραφούν μια ιστορία οδύνης, αλλά και ηρωικής δύναμης για επιβίωση.\n\nΗ Λουσιάνα βρίσκεται αντιμέτωπη με θανάσιμους κινδύνους, καθώς η αλήθεια που αποκαλύπτεται αλλάζει τις ισορροπίες. Ο Αμπάστε και οι Λύκοι ξεχύνονται, σκορπώντας θάνατο και τρόμο. Η Ελβένυα ακροβατεί μεταξύ ζωής και θανάτου, όπου μια λάθος κίνηση σημαίνει τον αφανισμό της οικογένειάς της.\n\nΠοιος θα ακούσει το τραγούδι ενός καταστροφικού έρωτα, όταν οι συνέπειές του έχουν βυθίσει τον κόσμο σε μια ατέρμονη σύγκρουση;',
      blurbCoda: '',
      coverCaption: 'Ελληνικη εκδοση · Εκδοσεις Πηγη',
    },
    author: {
      heading: 'Ο Συγγραφέας',
      bio:
        'Ο Αλέξανδρος Παπαδάκης είναι συγγραφέας φαντασίας από την Αθήνα και δημιουργός της σειράς Η Οργή ενός Ρέκβιεμ.\n\nΓράφει από παιδί, με αφετηρία χαρακτήρες που επέμεναν να επιστρέφουν στο μυαλό του και ιστορίες γύρω από τραγικούς ήρωες, σκοτεινούς κόσμους και το τίμημα των επιλογών.\n\nΤο έργο του αντλεί από τη γοτθική αισθητική, το σκοτεινό fantasy, και την κλασική λογοτεχνία. Ο Χορός των Βέσπερσεϊντ είναι το πρώτο βιβλίο της σειράς.',
      facts: {
        born: 'Κρήτη',
        lives: 'Ελλάδα',
        subject: 'Πολιτική τραγωδία σε dark fantasy',
      },
    },
    newsletter: {
      heading: 'Μάθε πρώτος τα νέα της σειράς',
      body:
        'Εγγραφείτε για ενημερώσεις σχετικά με τις επόμενες κυκλοφορίες, ειδικά νέα και υλικό από τον κόσμο του Ρέκβιεμ.',
      placeholder: 'Η διεύθυνση email σου',
      submit: 'Εγγραφή',
      submitting: 'Αποστολή…',
      success: 'Ευχαριστούμε. Η επόμενη λέξη από το ρέκβιεμ θα σε βρει εδώ.',
      error: 'Κάτι πήγε στραβά. Δοκίμασε ξανά σε λίγο.',
      privacy: 'Απεγγραφή οποιαδήποτε στιγμή',
    },
    buy: {
      heading: 'Πού θα το διαβάσεις',
      body:
        'Η ελληνική έκδοση κυκλοφορεί από τις Εκδόσεις Πηγή και διατίθεται στα ακόλουθα σημεία πώλησης.',
      comingSoon: 'Σύντομα',
      open: 'Αγορά',
    },
    footer: {
      tagline: 'Μια σειρά σκοτεινής επικής φαντασίας από τον Αλέξανδρο Παπαδάκη.',
      copyright: '© {{year}} Alexandros Papadakis. All rights reserved.',
      contact: 'Επικοινωνια',
      follow: 'Ακολουθησε',
    },
    cookies: {
      title: 'Σχετικά με τα cookies',
      body:
        'Χρησιμοποιούμε cookies για να κατανοήσουμε πώς οι αναγνώστες βρίσκουν τη σελίδα και να βελτιώσουμε την εμπειρία σου. Μπορείς να αρνηθείς χωρίς καμία επίπτωση.',
      accept: 'Αποδοχή',
      decline: 'Άρνηση',
    },
  },
};
